import { rfqRequestQuoteHeaderStyles } from "@insite/content-library/Widgets/RfqRequestQuote/RfqRequestQuoteHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

rfqRequestQuoteHeaderStyles.titleText = {
    variant: "h2",
    css : css `
    ${({ theme }: { theme: BaseTheme }) =>
    breakpointMediaQueries(theme, [
        css`
            padding: 0 10px;
            `,
        css`
            padding: 0 10px;
            `,
        null,
        null,
        null,
    ])}
    `
}